import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const ContactPlace = props => {
    const hoursList = props.hours.map((el, i) => {
        return (
            <li className="contact-place__list-element" key={`day_${i}`}>
                <span className="contact-place__day">{el[0]}</span>
                <span className="contact-place__hours">{el[1]}</span>
            </li>
        );
    });

    return (
        <section className={`contact-place${props.lastItem ? ' contact-place--last-item' : ''}`}>
            <div className="container contact-place__container">
                <div className="contact-place__image-box">
                    <LazyLoadImage effect="blur" className="contact-place__image" src={props.image} alt={props.alt} />
                </div>
                <div className="contact-place__data-box">
                    <div className="contact-place__container">
                        <div className="contact-place__title">
                            <span className="contact-place__name">{props.name}</span>
                        </div>
                        <div className="contact-place__address">
                            <svg className="contact-place__icon" width="29" height="39" viewBox="0 0 29 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0098 38.2131C2.0368 22.1684 0 20.5217 0 14.625C0 6.54781 6.49185 0 14.5 0C22.5082 0 29 6.54781 29 14.625C29 20.5217 26.9632 22.1684 15.9902 38.2131C15.2701 39.2623 13.7298 39.2623 13.0098 38.2131ZM14.5 20.7188C17.8367 20.7188 20.5417 17.9905 20.5417 14.625C20.5417 11.2595 17.8367 8.53125 14.5 8.53125C11.1633 8.53125 8.45833 11.2595 8.45833 14.625C8.45833 17.9905 11.1633 20.7188 14.5 20.7188Z" fill="white"/>
                            </svg>
                            <span className="contact-place__address-text">{props.address}</span>
                        </div>
                        <div className="contact-place__hours-box">
                            <svg className="contact-place__icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 0.625C9.29688 0.625 0.625 9.29688 0.625 20C0.625 30.7031 9.29688 39.375 20 39.375C30.7031 39.375 39.375 30.7031 39.375 20C39.375 9.29688 30.7031 0.625 20 0.625ZM20 35.625C11.3672 35.625 4.375 28.6328 4.375 20C4.375 11.3672 11.3672 4.375 20 4.375C28.6328 4.375 35.625 11.3672 35.625 20C35.625 28.6328 28.6328 35.625 20 35.625ZM24.8281 27.4688L18.1953 22.6484C17.9531 22.4688 17.8125 22.1875 17.8125 21.8906V9.0625C17.8125 8.54688 18.2344 8.125 18.75 8.125H21.25C21.7656 8.125 22.1875 8.54688 22.1875 9.0625V20.1328L27.4062 23.9297C27.8281 24.2344 27.9141 24.8203 27.6094 25.2422L26.1406 27.2656C25.8359 27.6797 25.25 27.7734 24.8281 27.4688Z" fill="white"/>
                            </svg>
                            <ul className="contact-place__hours-list">
                                {hoursList}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactPlace;